exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width: 375px) {\n  .card__CardFinancePurchase-module___ulcBK {\n    min-width: 260px;\n  }\n  .list__CardFinancePurchase-module___20wb- {\n    font-size: 12px;\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"card": "card__CardFinancePurchase-module___ulcBK",
	"list": "list__CardFinancePurchase-module___20wb-"
};